var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"pa-3",attrs:{"headers":_vm.headers,"items":_vm.translatedItems,"loading":_vm.loading,"disable-pagination":"","disable-sort":"","hide-default-footer":""}})}
var staticRenderFns = []

export { render, staticRenderFns }